import { linkListStyles } from "@insite/content-library/Widgets/Basic/SocialLinks";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        padding: 10px 0;
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        padding: 0;
        margin-right: 0;
        flex-shrink: 0;
    `,
};
